import _ from "lodash";

/*
 * Konstantendefinitionen zur Festlelegung abweichender URLs je Teilprojekt in den Common Modulen
 * Variante: SHK (e-Portal)
 */

// UI-Einstellungen (Sortierung, Spalten etc.)
export const ENDPOINT_SETTINGS = "/api/shknutzer/einstellungen";

// Registrierung / Login / Sessions
export const ENDPOINT_REGISTER = "/api/shkauthentifizierung/registrierung";
export const ENDPOINT_LOGIN = "/api/shkauthentifizierung/anmeldung/login";
export const ENDPOINT_LOGOUT = "/api/shkauthentifizierung/anmeldung/logout";
export const ENDPOINT_REFRESH = "/api/shkauthentifizierung/anmeldung/refresh";

export const ENDPOINT_CATALOGS = "/api/shkkatalog/katalog";

export const ROLLEN = {
  ROLLE_DEKANAT: "3b10928d-6c80-4aec-8369-d7e94ae3c92d",
  ROLLE_GLEICHSTELLUNG: "4a1d4c98-6d35-11e7-9a46-000475da4ddb",
  ROLLE_SBV: "7589513e-de8b-40a2-a5fc-f075aae3d4d8",
  ROLLE_PERSONALRAT: "8dc48400-f9e9-401e-91bd-e1fdd0c60e6a",
  ROLLE_PERSONALRAT_TUV: "dd0d4234-7dfe-11e9-bf72-000475da4ddb",
  ROLLE_ANTRAGSTELLER: "ad4f269c-621d-11e7-88e0-000475da4ddb",
  ROLLE_AUSSENWIRTSCHAFT: "318ceb09-4877-4f15-803e-00e53a4dd7ec",

  ROLLE_SACHBEARBEITER_SHK: "c56d6826-6c98-11e7-a6b1-000475da4ddb", // 4.3.4
  ROLLE_SACHBEARBEITER_TARIF: "5f66deae-7dfd-11e9-a8bd-000475da4ddb", // 4.3.2
  ROLLE_SACHBEARBEITER_BEAMTE: "4d1ebdec-7dfe-11e9-8cd5-000475da4ddb", // 4.2.2
  ROLLE_SACHBEARBEITER_PERSONAL: "a69ac352-7dfe-11e9-a4d3-000475da4ddb", // 4.2.1
  ROLLE_SACHBEARBEITER_LEHRAUFTRAG: "c56d6826-6c98-11e7-a6b1-000475da4ddb", // 4.3.4, gleich wie SHK, gibt noch keine eigene Rolle

  ROLLE_DEZ1_3: "9b9357e4-3524-11e9-877a-000475da4ddb",
  ROLLE_DEZ1_1: "e35fa374-3520-11e9-b4fb-000475da4ddb",
  ROLLE_ADMIN: "fac72f56-60a0-11e7-a5f6-000475da4ddb",
  ROLLE_PROFESSOR: "57d27e8e-9df6-11e7-b65c-000475da4ddb",
  ROLLE_PERSONALLEITUNG: "b3b51c33-772a-4b63-923b-184f648304cd",
  ROLLE_SACHGEBIETSLEITUNG: "7958638f-d6f6-46ec-b8ce-988a4051673f",
};

export const ROLLEN_SACHB = [
  ROLLEN.ROLLE_SACHBEARBEITER_SHK,
  ROLLEN.ROLLE_SACHBEARBEITER_TARIF,
  ROLLEN.ROLLE_SACHBEARBEITER_BEAMTE,
  ROLLEN.ROLLE_SACHBEARBEITER_PERSONAL,
  ROLLEN.ROLLE_SACHBEARBEITER_LEHRAUFTRAG,
  ROLLEN.ROLLE_SACHGEBIETSLEITUNG,
];

export const ROLLEN_PR = [
  ROLLEN.ROLLE_PERSONALRAT,
  ROLLEN.ROLLE_PERSONALRAT_TUV,
];

export const ROLLEN_PRUEFVERMERK = [
  ROLLEN.ROLLE_AUSSENWIRTSCHAFT,
  ROLLEN.ROLLE_DEZ1_3,
  ROLLEN.ROLLE_ADMIN,
];

// Rollen mit Dashboard
export const ROLLEN_DASHBOARD = [
  ROLLEN.ROLLE_DEZ1_3,
  ROLLEN.ROLLE_SACHBEARBEITER_SHK,
  ROLLEN.ROLLE_SACHBEARBEITER_TARIF,
  ROLLEN.ROLLE_SACHGEBIETSLEITUNG,
];

export function userDashboard(user) {
  // Gehört User zur Kategorie Sachbearbeiter?
  return ROLLEN_DASHBOARD.indexOf(user.ro_id) >= 0;
}


export function userSachb(user) {
  // Gehört User zur Kategorie Sachbearbeiter?
  return ROLLEN_SACHB.indexOf(user.ro_id) >= 0;
}

export function userAntragsteller(user) {
  // Ist User Antragsteller?
  return user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER;
}


export function userSachbErweitert(user) {
  // Gehört User zur Kategorie erweiterte Sachbearbeiter?
  return userSachb(user) || user.ro_id == ROLLEN.ROLLE_DEZ1_3;
}


export function userRollePersonalrat(ro_id) {
  return ROLLEN_PR.indexOf(ro_id) >= 0;
}

export function userPersonalrat(user) {
  // Gehört User zur Kategorie Personalrat?
  return userRollePersonalrat(user.ro_id);
}

export function userPersonalratTuv(user) {
  return user.ro_id == ROLLEN.ROLLE_PERSONALRAT_TUV;
}

export function userPersonalratWiss(user) {
  return user.ro_id == ROLLEN.ROLLE_PERSONALRAT;
}

export const LAND = {
  LAND_DEUTSCHLAND: "a2c0483a-c66e-4d74-817e-e743d37d80b4",
};

export const FINANZAMT = {
  ANDERES: "91b4a44c-5779-4341-8688-703f2a5f1506",
};

export const PFLICHTANLAGEN = {
  IDENTITÄTSNACHWEIS: "a60cfa76-8720-11e7-b5e5-000475da4ddb",
  AUFENTHALTSTITEL: "a6f22074-8720-11e7-8761-000475da4ddb",
  QUITTUNG_FÜHRUNG: "a8231110-8720-11e7-8d7a-000475da4ddb",
};

export const VERTRAGSARTEN_SHK = [
  "f15967e7-78de-4d6c-8450-6cdbfb2a5a61",
  "e019a20a-9a10-46ed-9c04-73f434a024de",
  "3c5be90a-df5e-4df4-a4d9-b66e3b490d21",
];

export const VERTRAGSARTEN = {
  WHK: "f15967e7-78de-4d6c-8450-6cdbfb2a5a61",
  SHK: "e019a20a-9a10-46ed-9c04-73f434a024de",
  WHF: "3c5be90a-df5e-4df4-a4d9-b66e3b490d21",
};

// Dummy-Vertragsart "Vertragsart auswählen" (svakey 9999)
export const VERTRAGSART_AUSWAEHLEN = "a8539469-b759-41f7-a5d9-c6b91e480adc";

export const VERTRAGSARTEN_WERKVERTRAG = [
  "af8d34f4-35dd-11e9-8751-000475da4ddb",
];

export const VERTRAGSARTEN_LEHRAUFTRAG = [
  "a76c3524-a3d5-4a05-b957-f85284526487",
];

export const VERTRAGSARTEN_VORTRAG = [
  "0a1be3e1-7ad4-4054-82e9-fa1bc9bcb56e",
];


/*
 * PBP-2241 alle die mit svakey 21 und 22 anfangen
 * Vertragsart kommt aus pbp immer als 2100, aber kann im e-portal geändert werden???
 */
export const VERTRAGSARTEN_TARIF = [
  "2e16b4af-5a2b-4afe-a563-1f8890712fd5", // 2100
  "e488d586-5182-490c-8b73-34be14a4c54a",
  "1279de6d-4b87-45de-b3ad-b1b500efb2db",
  "f4bffc2c-962d-410b-b29c-7de1c5ee8ad5",
  "1dac1787-1072-4b57-9aca-f7d0efb05bc5",
  "2af53433-eb1a-40b2-9dff-c5580b2429c6",
  "907e3748-341b-4804-af65-c58582449c81",
  "99a9c25c-8273-4701-9a5c-ce1ecfaecf0a",
  "dce20e52-8fe9-4e82-8db6-e09728d9b313",
  "ee28e016-7121-4622-8596-0b8fb935c0df",
  "6d4685b4-b8c7-4966-a4ce-26bf3bdd8b21",
  "3c6260b0-dda1-47cf-b7ff-2da8cbcd2100",
  "c52b0266-29cc-4f6f-8954-88e947caa0af",
  "58324ef8-ae28-4dc7-8c68-bfbcd25a3734",
  "99453795-f575-4a1c-a43a-354a551606ff",
  "be96a43e-be7c-4233-bab1-906a46fdb2fc",
  "733e2228-8018-4878-bf31-971e891df752",
  "2fa43968-f62d-461e-83d0-2672587160f8",
  "bb10b6c5-77e0-4178-b270-dd566f7a7b98",
  "009ee1ce-3e9d-4744-a0a2-96152d402e6d",
];


export const ANTRAGSTATUS = {
  STATUS_NEU: "b84bbd1c-778a-11e7-a769-000475da4ddb",
  STATUS_UEBERARBEITEN: "b2d6e8b4-7b56-11e7-b896-000475da4ddb",
  STATUS_DIENSTVERTRAG_ERSTELLEN: "f8e5f192-7075-11e7-9c3d-000475da4ddb",
  STATUS_TARIFVERTRAG_ERSTELLEN: "f8e5f192-7075-11e7-9c3d-000475da4ddb", // TODO: richtige id setzen, wenn workflow umgesetzt
  STATUS_VERTRAGSUNTERLAGEN_UNVOLLSTAENDIG: "1368fb48-f639-4620-b61f-47423a1e6bdc",
  STATUS_WERKVERTRAG_ERSTELLEN: "c0706cbe-352e-11e9-b698-000475da4ddb",
  STATUS_DATEN_AN_SVA: "fa16f0ca-7075-11e7-8f1f-000475da4ddb",
  STATUS_TARIFDATEN_AN_SVA: "e7c5d1d0-25a6-4fdb-941e-5c176b73643b",
  STATUS_DIENSTVERTRAG_ABGESCHLOSSEN: "6564a15d-4b27-4b6a-bd30-a1228b3009c6",
  STATUS_TARIFVERTRAG_ABGESCHLOSSEN: "5d7d4011-f26b-4ee0-96f4-cb1c19a2d1e0",
  STATUS_WERKVERTRAG_ABGESCHLOSSEN: "6a37a824-3530-11e9-8950-000475da4ddb",
  STATUS_LEHRAUFTRAG_ABGESCHLOSSEN: "40c47024-3ae1-4b41-8b58-f89fd49b1976",
  STATUS_ANTRAG_ABGEBROCHEN: "88b5df80-ed3a-401e-8e3a-89cc4f34d332",
  STATUS_ÄNDERUNG_ERFORDERLICH: "48f7636e-ea32-4670-853e-1dfbfa2068b3",
  STATUS_ÄNDERUNG_ERFORDERLICH_413: "3b1656bc-0449-405f-b97f-4269fd451e22",
  STATUS_UNTERZEICHNUNG_DEZ4: "f790336c-c676-49ce-b506-0914ca26fa5e",
  STATUS_ABGEBROCHEN: "88b5df80-ed3a-401e-8e3a-89cc4f34d332",
  STATUS_TARIF_VOLLSTAENDIG_GEPRUEFT: "b7165679-918a-485c-ab32-99111b1ebf85", // Antrag vollständig geprüft (Tarif)

  STATUS_PR_FREIGEGEBEN: "d07fd684-806b-11e9-ad3a-000475da4ddb", // Werkvertrag
  STATUS_PR_ABGELEHNT: "54d9126a-806c-11e9-8428-000475da4ddb", // Werkvertrag
  STATUS_PR_WISS_AV_MOEGLICH: "c9ac1d2c-1042-4423-84dc-111a2f91f9e0", // PR-Wiss Arbeitsvertrag möglich
  STATUS_PR_TUV_AV_MOEGLICH: "da7e3e82-1f82-447c-bd17-8141c7843024", // PR-TuV Arbeitsvertrag möglich
  STATUS_PR_WISS_AV_TEILWEISE: "3bae2a53-31d4-4f83-a8c0-0e63092b7b8e", // PR-Wiss Arbeitsvertrag teilweise möglich
  STATUS_PR_TUV_AV_TEILWEISE: "dfff4fe4-a65f-43b3-9d3c-b7ed1fd0914b", // PR-TuV Arbeitsvertrag teilweise möglich

  STATUS_VORPRÜFUNG_413: "e75c7a53-b6d5-47da-90ba-f6a0db78978e",

  STATUS_GSB_PRUEFUNG: "ec7d44e6-7075-11e7-a20b-000475da4ddb",
  STATUS_GSB_PRUEFUNG_ERNEUT: "64b0ab88-199d-4cbe-bc9d-a542869bfd5e",

  STATUS_SACHGEBIETSLEITUNG: "fcebacf8-53d8-417a-8b31-5153a2e4b63e",

  STATUS_VORTRAG_ABGESCHLOSSEN: "0ad2ed5e-622f-4c37-910e-5a1ebc5db745",
  STATUS_VORTRAG_PRUEFUNG: "e9634060-351f-11e9-a23a-000475da4ddb",
  STATUS_VORTRAG_PRUEFUNG_AUSSENWIRTSCHAFT: "94aaacee-f144-41cc-98a2-cd9159ef2bb5", // Antrag in Prüfung (Außenwirtschaft)

};

export const PR_ENTSCHEIDUNGEN = [
  ANTRAGSTATUS.STATUS_PR_FREIGEGEBEN,
  ANTRAGSTATUS.STATUS_VORPRÜFUNG_413,
  ANTRAGSTATUS.STATUS_TARIF_VOLLSTAENDIG_GEPRUEFT,
  ANTRAGSTATUS.STATUS_PR_WISS_AV_MOEGLICH,
  ANTRAGSTATUS.STATUS_PR_TUV_AV_MOEGLICH,
  ANTRAGSTATUS.STATUS_PR_WISS_AV_TEILWEISE,
  ANTRAGSTATUS.STATUS_PR_TUV_AV_TEILWEISE,
];

export const GSB_PRUEFUNGEN = [ANTRAGSTATUS.STATUS_GSB_PRUEFUNG, ANTRAGSTATUS.STATUS_GSB_PRUEFUNG_ERNEUT];

export const ANTRAGSTYPEN = {
  NEUEINSTELLUNG: "13146eda-707c-11e7-8012-000475da4ddb",
  WERKVERTRAG: "d58673c2-351b-11e9-9538-000475da4ddb",
  HONORARVERTRAG: "48894d70-a6b8-4a02-9359-fde9d8a48da0",
  WIEDERHOLUNGSANTRAG: "4c0d0e87-c0dc-4ea0-bc1c-4ede88468863",
};

export function istTypWerkvertrag(kat_id) {
  // Entspricht Typ Werk- oder Honorarvertrag?
  return [ANTRAGSTYPEN.WERKVERTRAG, ANTRAGSTYPEN.HONORARVERTRAG].indexOf(kat_id) >= 0;
}

export function istTypLehrauftrag(kat_id) {
  // Entspricht Typen NUR für Lehrauftrag
  return [ANTRAGSTYPEN.WIEDERHOLUNGSANTRAG].indexOf(kat_id) >= 0;
}

export function istArtTarifvertrag(art_id) {
  return VERTRAGSARTEN_TARIF.indexOf(art_id) >= 0;
}

export function antragtypBearbeitbar(antrag, user) {
  // Feststellen ob Typ des Antrags vom User bearbeitet werden kann
  if (istTypWerkvertrag(antrag.a_katid) || VERTRAGSARTEN_VORTRAG.indexOf(antrag.a_artid) >= 0) {
    return user.ro_id == ROLLEN.ROLLE_DEZ1_3;
  }
  return userSachb(user);
}

export function antragtypBeginnVerschiebbar(antrag, user) {
  // Feststellen ob Maßnahme(n) zu Typ des Antrags vom User eingeschränkt bearbeitet werden kann
  return userSachb(user);
}

export const SICHTBARKEIT = {
  SICHTBAR_FÜR_MICH: "02af3f36-1bd3-4bd0-8f79-389642b912e2",
  SICHTBAR_FÜR_ROLLE: "733b324d-f2e7-4a82-95a4-ef562fd00eda",
  SICHTBAR_FÜR_UNI: "97e43990-9eaa-11e7-8663-000475da4ddb",
  SICHTBAR_FÜR_ROLLE_UND_PA: "0969d0ee-a791-11e8-b5c3-000475da4ddb",
  SICHTBAR_FÜR_ALLE: "6182cf0b-d384-4a9f-808d-4dde45b1ff7a",
  SICHTBAR_FÜR_ROLLE_SBV_PA_PR: "c60a193a-4566-42bf-a229-d6e36428f919",
};

export const ABSCHLUSSART = {
  OHNE_ABSCHLUSS: "38ef29b4-caab-4ee9-ae43-96cbd7c8b503",
  HABILITIERT: "3b1352d8-b1cd-41da-9897-ac1e8b40c958",
};

export const HOCHSCHULE = {
  HS_IM_AUSLAND: "52e7bc3f-8d32-432b-a9cb-eb740f70a4d8",
};

export const config = {
  data: {

    // TODO: weitere Vertragsarten hinzufügen, default sind 2 Wochen
    EINSTELLUNG_PUFFER_WOCHEN: {
      "2e16b4af-5a2b-4afe-a563-1f8890712fd5": 3, // Vertragsart Tarif 2100
      "f15967e7-78de-4d6c-8450-6cdbfb2a5a61": 3, // Vertragsart WHK
      "e019a20a-9a10-46ed-9c04-73f434a024de": 2, // Vertragsart SHK
      "3c5be90a-df5e-4df4-a4d9-b66e3b490d21": 3, // Vertragsart WHF
    }, // Unterschreiten verhindert Speichern/Einreichen
    EINSTELLUNG_PUFFER_WOCHEN_DEFAULT: 2, // wenn kein Wert zu konkreter Vertragsart gefunden wird
    EINSTELLUNG_WARNUNG_WOCHEN: 8, // Unterschreiten erzeugt Warnung
    // ...

  },
  getValue: function(name) {
    return this.data[name];
  },
};

export const MASSNAHMEEIGENSCHAFT = {
  shk_whf_whk_person: "1ce29691-db2d-4696-b790-287e0b427ec1",
  laufbahn: "1dfed1f6-5d2a-4065-8c9f-6d7ed955e562",
  vertragsart: "1fbca552-21a6-4dfc-8d90-e53f8dd9a059",
  lehrauftrag: "26233259-acff-4ddc-94a1-ba0486f04803",
  stellenbesetzung: "336b5326-8b0f-48b7-9b55-afa5172f6854",
  zahlung: "58ee7148-fb31-4f84-b3dc-03a9b3184d56",
  zulage: "618bd6ce-5dc0-4ebe-a422-e3100dc23608",
  whk_qualiziel: "633185db-6a5e-4297-8237-18942bd97652",
  reservierung: "6785d945-9fa9-4429-a105-7231793a91f5",
  finanzierung: "6fe5b52c-e700-4080-a59b-e38016d8e1a3",
  shk_whf_whk_taetigkeit: "734c0f49-7a94-4c00-87d6-015e10c54294",
  finanzierungsstruktur: "980dac19-df8c-4a2c-99c2-dc4473ba48a6",
  familienstand: "9d134a69-d5a6-418f-8840-6545f956741e",
  betrag: "b096f8bd-ae80-4e3f-9a8d-096bb4d7478c",
  arbeitszeit: "de3bc4fc-3775-4650-bf44-3518f3cae889",
  urlaub: "e4f04989-9a74-40aa-911d-9db760eca555",
  deputat: "ec08facc-470b-4d96-885a-444ca92c4f98",
};

/*
 * Key hier muss passen mit ASTMODUSKEY unten
 * Nummern nicht ändern bei produktivem Datenbestand (alte Werte in hilfe_astmodus table)! Hinzufügen ok
 */
export const ANTRAGSTELLERMODUS = {
  1: {
    value: 1,
    label: "Mein Ziel: Hilfskraft",
    klabel: "Hilfskraft",
    desc: "In diesem Modus werden Angebote für studentische und wissenschaftliche Hilfskräfte dargestellt.",
    labelAntragstellung: "Einstellungsantrag stellen",
    labelAntrag: "Antrag auf Beschäftigung als Hilfskraft",
    labelVertrag: "Arbeitsvertrag",
    filterMassnahmen: data => _.filter(data, row => VERTRAGSARTEN_SHK.indexOf(row.m_artid) >= 0),
    filterAnträge: (data, nurAktiv) => _.filter(data, row => _.find(row.massnahmen, m => VERTRAGSARTEN_SHK.indexOf(m.m_artid) >= 0 && (!nurAktiv || row.a_asid != ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN))),
    statusAbgeschlossen: ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN,
    statusErstellen: ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ERSTELLEN,
    vertragsarten: VERTRAGSARTEN_SHK,
    manualLink: "/docs/Antragsannahme_e-Portal_Hilfskräfte.pdf",
  },

  2: {
    value: 2,
    label: "Werk- / Honorarvertragsnehmer*in (Privat)",
    klabel: "Werk- / Honorarvertragsnehmer*in",
    desc: "In diesem Modus werden Angebote für Werks- und Honorarverträge im privaten Kontext dargestellt.",
    labelAntragstellung: "Antrag auf Werkvertrag stellen",
    labelAntrag: "Antrag auf einen Werkvertrag",
    labelVertrag: "Vertrag",
    labelVorgesehene: "vorgesehene, geplante Werkverträge",
    filterMassnahmen: data => _.filter(data, row => VERTRAGSARTEN_WERKVERTRAG.indexOf(row.m_artid) >= 0),
    filterAnträge: (data, nurAktiv) => _.filter(data, row => _.find(row.massnahmen, m => VERTRAGSARTEN_WERKVERTRAG.indexOf(m.m_artid) >= 0 && (!nurAktiv || row.a_asid != ANTRAGSTATUS.STATUS_WERKVERTRAG_ABGESCHLOSSEN))),
    statusAbgeschlossen: ANTRAGSTATUS.STATUS_WERKVERTRAG_ABGESCHLOSSEN,
    statusErstellen: ANTRAGSTATUS.STATUS_WERKVERTRAG_ERSTELLEN,
    vertragsarten: VERTRAGSARTEN_WERKVERTRAG,
  },

  3: {
    value: 3,
    label: "Mein Ziel: Lehrbeauftragte*r",
    klabel: "Lehrbeauftragte*r",
    desc: "In diesem Modus werden Angebote für Lehraufträge dargestellt.",
    labelAntragstellung: "Antrag auf Lehrauftrag stellen",
    labelAntrag: "Antrag auf einen Lehrauftrag",
    labelVertrag: "Auftrag",
    labelVorgesehene: "vorgesehene Beauftragungen",
    labelVertragUnterschrieben: "Unterschriebene Beauftragung",
    labelEinstellungsprozess: "Antragsprozess",
    labelButtonAntragStellen: "Antrag annehmen",
    // labelPrüfungsstelleMitArtikel: "die Beschaffungsstelle",
    filterMassnahmen: data => _.filter(data, row => VERTRAGSARTEN_LEHRAUFTRAG.indexOf(row.m_artid) >= 0),
    filterAnträge: (data, nurAktiv) => _.filter(data, row => _.find(row.massnahmen, m => VERTRAGSARTEN_LEHRAUFTRAG.indexOf(m.m_artid) >= 0 && (!nurAktiv || row.a_asid != ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN))),
    statusAbgeschlossen: ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN,
    vertragsarten: VERTRAGSARTEN_LEHRAUFTRAG,
    manualLink: "/docs/Antragsannahme_e-Portal_Lehrauftrag.pdf",
    manualLinkEn: "/docs/e_Portal_lectureships.pdf",
    // statusErstellen: ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ERSTELLEN <- Lehraufträge sollen hier nicht gelistet werden
  },
  4: {
    value: 4,
    label: "Mein Ziel: Tarifbeschäftigte*r",
    klabel: "Tarifbeschäftigte*r",
    desc: "In diesem Modus werden Angebote für Tarifbeschäftigte dargestellt.",
    labelAntragstellung: "Antrag auf Arbeitsvertrag stellen",
    labelAntrag: "Antrag auf einen Arbeitsvertrag",
    // PBP-2471 Bei Tarifbeschäftigten muss es immer Arbeitsvertrag (nicht Dienstvertrag) heißen
    labelVertrag: "Arbeitsvertrag",
    filterMassnahmen: data => _.filter(data, row => VERTRAGSARTEN_TARIF.indexOf(row.m_artid) >= 0),
    filterAnträge: (data, nurAktiv) => _.filter(data, row => _.find(row.massnahmen, m => VERTRAGSARTEN_TARIF.indexOf(m.m_artid) >= 0 && (!nurAktiv || row.a_asid != ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN))),
    statusAbgeschlossen: ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN,
    // statusErstellen: ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ERSTELLEN,<- Tarifverträge sollen hier nicht gelistet werden
    statusErstellen: ANTRAGSTATUS.STATUS_TARIF_VOLLSTAENDIG_GEPRUEFT,
    vertragsarten: VERTRAGSARTEN_TARIF,
    manualLink: "/docs/Antragsannahme_e-Portal_Tarif.pdf",
    manualLinkEn: "/docs/Antragsannahme_e-Portal_Tarif_EN.pdf",
  },
  5: {
    value: 5,
    label: "Mein Ziel: Referent*in (Vortrag/Kolloquium)",
    klabel: "Referent*in (Vortrag/Kolloquium)",
    desc: "In diesem Modus werden Angebote für Vorträge und Kolloquien dargestellt.",
    labelAntragstellung: "Antrag für einen Vortrag/ein Kolloquium stellen",
    labelAntrag: "Antrag für einen Vortrag/ein Kolloquium",
    labelVertrag: "Auftrag",
    labelVorgesehene: "vorgesehene Beauftragungen",
    labelVertragUnterschrieben: "Unterschriebene Beauftragung",
    labelEinstellungsprozess: "Antragsprozess",
    labelButtonAntragStellen: "Antrag annehmen",
    labelPrüfungsstelleMitArtikel: "die zentrale Vergabestelle",
    labelWillkommenstext: "Hier haben Sie die Möglichkeit für den Vortrag/das Kolloquium einen Antrag zu erstellen und elektronisch beim Finanzdezernat einzureichen.",
    filterMassnahmen: data => _.filter(data, row => VERTRAGSARTEN_VORTRAG.indexOf(row.m_artid) >= 0),
    filterAnträge: (data, nurAktiv) => _.filter(data, row => _.find(row.massnahmen, m => VERTRAGSARTEN_VORTRAG.indexOf(m.m_artid) >= 0 && (!nurAktiv || row.a_asid != ANTRAGSTATUS.STATUS_VORTRAG_ABGESCHLOSSEN))),
    statusAbgeschlossen: ANTRAGSTATUS.STATUS_VORTRAG_ABGESCHLOSSEN,
    vertragsarten: VERTRAGSARTEN_VORTRAG,
  },
};
export const ASTMODUSKEY = {
  Hilfskraft: 1,
  WerkPrivat: 2,
  Lehrauftrag: 3,
  Tarif: 4,
  Vortrag: 5,
};

export const ASTMODUSEMPTY = -1;

// Statuswerte aller Modi kategorisieren
export const ALLEMODI = {
  statusAbgeschlossen: _.map(ANTRAGSTELLERMODUS, item => item.statusAbgeschlossen),
  statusErstellen: _.reduce(ANTRAGSTELLERMODUS, (result, item) => {
    if (item.statusErstellen) {
      result.push(item.statusErstellen);
    }
    return result;
  }, []),
};
export const getModusFromAntrag = function(antrag) {
  // Modus von Vertragsart eines Antrages ableiten
  if (VERTRAGSARTEN_SHK.indexOf(antrag.a_artid) >= 0) {
    return ASTMODUSKEY.Hilfskraft;
  } else if (VERTRAGSARTEN_WERKVERTRAG.indexOf(antrag.a_artid) >= 0) {
    return ASTMODUSKEY.WerkPrivat;
  } else if (VERTRAGSARTEN_LEHRAUFTRAG.indexOf(antrag.a_artid) >= 0) {
    return ASTMODUSKEY.Lehrauftrag;
  } else if (VERTRAGSARTEN_TARIF.indexOf(antrag.a_artid) >= 0) {
    return ASTMODUSKEY.Tarif;
  } else if (VERTRAGSARTEN_VORTRAG.indexOf(antrag.a_artid) >= 0) {
    return ASTMODUSKEY.Vortrag;
  }
  return null; // Nicht implementiert
};

export const WBTYPE = {
  Hilfskraft: 1,
  Ausserhalb: 2,
  Lehrauftrag: 3,
  Befristet_12Monate: 4,
};

export const DOKUMENTARTEN = {
  ANLAGE_PR: "7ce42ac1-db4a-40b3-9d36-0c634c239e0a",
  VORLAGE_PR: "04c9e2df-2802-4d1d-a883-0592853320da",
};

export const VERWALTUNG_KANZLER = "ee4c0821-1152-4e48-808b-40da981c7dd0";
